import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function InspectionAlarm() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">주취급 단지에 실거래가 발생하거나, 계약 만기/등기 변동이 발생되면 이실장 앱으로 알려 드려요.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<ol className="list_order"><li><h4 className="order_num">Step 1</h4><p className="order_desc">이실장 앱의 알림 설정에서 받고 싶은 만기 알림 시기를 설정하실 수 있어요.</p><Image className="img_guide" src="/image/desktop/popup/inspection02_01.png" alt={"\uC774\uC2E4\uC7A5 \uC571\uC758 \uC54C\uB9BC \uC124\uC815\uC5D0\uC11C \uBC1B\uACE0 \uC2F6\uC740 \uB9CC\uAE30 \uC54C\uB9BC \uC2DC\uAE30\uB97C \uC124\uC815\uD558\uC2E4 \uC218 \uC788\uC5B4\uC694."} width={100} height={100} /></li><li><h4 className="order_num">Step 2</h4><p className="order_desc">실거래, 만기, 등기변동사항 발생 시 이실장 앱 알림으로 보내 드려요.</p><Image className="img_guide" src="/image/desktop/popup/inspection02_02.png" alt={"\uC2E4\uAC70\uB798, \uB9CC\uAE30, \uB4F1\uAE30\uBCC0\uB3D9\uC0AC\uD56D \uBC1C\uC0DD \uC2DC \uC774\uC2E4\uC7A5 \uC571 \uC54C\uB9BC\uC73C\uB85C \uBCF4\uB0B4 \uB4DC\uB824\uC694."} width={100} height={100} /></li></ol></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}